<template>
  <v-container fluid id="login" fill-height tag="section" class="loginscreen-background">
    <v-row justify="end">
      <v-col offset-md="7" offset-sm="6">
        <v-card elevation="10" light max-width="100%" width="400" class="pa-3" rounded="lg">
          <v-img class="mx-auto mt-4 mb-2" max-width="140" alt="Intellitots Admin" :src="tots_image"> </v-img>
          <v-card-text class="pb-2">
            <v-card-title class="pa-2 pl-0"> <v-icon left>mdi-textbox-password</v-icon>Authentication required </v-card-title>
            <v-card outlined rounded="lg">
              <v-card-subtitle class="pa-3 text-center">
                <dl>
                  <dt>We've sent the same OTP on your</dt>
                  <dd>
                    <strong v-if="phone"> Mobile No: {{ phone }}</strong>
                    <strong v-if="parentMobile"> Mobile No: {{ parentMobile }}</strong>
                  </dd>
                  <dd>
                    <strong> Email ID: {{ isStudent ? parentEmail || 'noemail@nodomain.com' : emailPhone || 'noemail@nodomain.com' }}</strong>
                  </dd>
                  <dt>Please enter it below to complete the verification.</dt>
                </dl>
              </v-card-subtitle>
            </v-card>
          </v-card-text>
          <form name="loginform2" @submit.prevent="login1">
            <template>
              <v-card-text class="pb-2">
                <v-text-field
                  type="number"
                  v-model="otp"
                  required
                  OnKeyPress="if(this.value.length == 6) return false"
                  @keyup="otpValidation"
                  color="grey darken-3"
                  label="Enter OTP"
                  placeholder=" "
                  prepend-icon="mdi-form-textbox-lock"
                  class="subtitle mb-0"
                  autofocus
                />
                <v-card-actions class="d-flex justify-end">
                  <v-btn elevation="1" small color="grey darken-1" class="white--text" :disabled="showCounter" @click="resendFunc"
                    >Resend OTP
                    <strong v-if="timeLeft > 0">: ({{ timeLeft }})</strong>
                  </v-btn>
                </v-card-actions>
                <v-card outlined rounded="lg" class="mt-2">
                  <v-card-subtitle class="pa-3 text-center">
                    <dl>
                      <dt>If you don’t have Mobile Number with you,</dt>

                      <dt>you can also enter the OTP sent on your</dt>
                      <dt>
                        <strong>Email ID: {{ isStudent ? parentEmail || 'noemail@nodomain.com' : emailPhone || 'noemail@nodomain.com' }}</strong>
                      </dt>
                    </dl>
                  </v-card-subtitle>
                </v-card>
              </v-card-text>
              <v-card-actions class="mr-2 mb-2" :class="{ 'd-block text-center': $vuetify.breakpoint.xs, 'd-flex justify-end': $vuetify.breakpoint.smAndUp }">
                <v-btn :class="{ 'mb-2': $vuetify.breakpoint.xs }" color="error" elevation="1" class="font-weight-bold order-2" type="submit" dark :loading="loading">
                  Login
                </v-btn>
                <v-btn :class="{ 'mb-2': $vuetify.breakpoint.xs }" class=" mr-2 order-1" @click="backToLogin" elevation="1"> Back to Login </v-btn>
              </v-card-actions>
            </template>
          </form>
        </v-card>
      </v-col>
    </v-row>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import CONSTANTS from '@/utils/constants'
// import Utils from '@/utils'
import stores from '@/stores'

// import http from 'axios'
import _ from 'lodash'

export default {
  name: 'Otp',
  props: ['referenceID'],
  data () {
    return {
      otp: '',
      tots_image: `${CONSTANTS.RAZORPAY.TOTS_IMAGE}`,
      resendFlag: false,
      emailPhone: '',
      phone: '',
      isMobile: '',
      isEmail: '',
      timeLeft: 0,
      showCounter: false,
      isLoading: false,
      resultant: '',
      loading: false,
      matches: [0],
      parentEmail: '',
      parentMobile: '',
      isStudent: false
    }
  },
  mounted () {},

  created: async function () {
    if (this.referenceID) {
      this.onStart()
    } else {
      this.$router.push('/login')
    }
  },

  watch: {
    timeLeft: function (time) {
      if (time === 0) {
        clearInterval(this.resultant)
        this.showCounter = false
        this.$dialog.notify.info('You can resend OTP', {
          position: 'top-right',
          timeout: 3000
        })
      }
    }
  },
  computed: {},
  methods: {
    otpValidation: function () {
      let reg = new RegExp('^[0-9]+$')
      let result = this.otp.match(reg)

      if (!result) {
        this.clearInput()
      }
    },
    clearInput: function () {
      this.otp = this.otp.replace('')

      return this.otp
    },
    backToLogin: function () {
      this.$router.push('/login')
    },

    ExceptionFun: function () {
      this.showCounter = true

      if (this.showCounter) {
        this.resultant = setInterval(() => {
          if (this.timeLeft === 0) {
            this.showCounter = false
          }

          this.timeLeft = this.timeLeft - 1
        }, 1000)
      }
    },
    resendFunc: function () {
      this.resendFlag = true
      this.onStart()
    },

    onStart: async function () {
      try {
        let payload = {
          referenceID: this.referenceID
        }

        if (this.resendFlag) {
          payload.isResend = this.resendFlag
        }

        this.isLoading = true
        if (this.resendFlag || this.referenceID) {
          const userInfoResponse = await http.post(`${CONSTANTS.API_URL}/api/admin/generateotp`, payload)
          console.log('userInfoResponse', userInfoResponse)
          this.isStudent = userInfoResponse.data.isStudent
          this.parentEmail = userInfoResponse.data.parentEmail
          this.parentMobile = userInfoResponse.data.parentMobile
          this.emailPhone = userInfoResponse.data.email
          this.phone = userInfoResponse.data.mobile
          this.isMobile = userInfoResponse.data.isMobile
          this.isEmail = userInfoResponse.data.isEmail
          this.timeLeft = userInfoResponse.data.timeout
        }
        if (this.timeLeft <= 60) {
          this.ExceptionFun()
        }

        if (this.resendFlag) {
          this.$dialog.notify.success('OTP Sent Successfully', {
            position: 'top-right',
            timeout: 3000
          })
        }
      } catch (e) {
        this.$router.push('/login')
        return this.$dialog.error({
          text: (e && e.response && e.response.data.message) + ' <br> ' + 'Please try again' || e.message,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    login1: async function () {
      console.log('login')

      try {
        this.loading = true
        let loginPayload = {
          password: this.otp,
          isOTP: true
        }
        if (this.isEmail) {
          loginPayload.email = this.emailPhone
        }
        if (this.isMobile) {
          loginPayload.email = this.phone
        }

        const { data } = await http.post(`${CONSTANTS.API_URL}/api/auth/local/admin`, loginPayload)
        this.loading = false
        await stores.user.setToken(data.token)
        await stores.user.setSuperAdmin(data.superAdmin)
        await stores.user.setAccess(data.access)
        await stores.user.refreshInfo()
        await stores.user.init()
        await stores.user.setMenu()
        if (stores.user.ACL.superAdmin) {
          this.$router.push({ name: 'Dashboard' })
        } else {
          let defaultRoute = _.find(stores.user.menu, item => item.dashboardRoleMap.isDefault)
          if (!_.isEmpty(defaultRoute)) {
            try {
              this.$router.push({ name: defaultRoute.name })
            } catch (e) {
              console.log('The error is =->', e)
              this.$router.push({ name: 'Profile' })
            }
          } else {
            this.$router.push({ name: 'Profile' })
          }
        }
      } catch (e) {
        this.loading = false
        return this.$dialog.error({
          text: (e && e.response && e.response.data.message) || e.message,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.loginscreen-background {
  background: url(http://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/background_Img.jpg);
  background-repeat: no-repeat;
}
</style>
